package com.dotdrives.repository
import com.dotdrives.client.GiverExperienceClient
import com.dotdrives.model.*
interface GiverExperienceRepository {
 suspend fun stats(orgId:String,giverId:String):Result<GiverExperienceStats>
 suspend fun gifts(orgId:String,giverId:String):Result<List<GiverGift>>
 suspend fun statements(orgId:String,giverId:String):Result<List<GiverStatement>>
 suspend fun files(orgId:String,giverId:String):Result<List<GiverFile>>
 suspend fun upload(orgId:String,giverId:String,name:String,mime:String,bytes:ByteArray):Result<Unit>
 suspend fun downloadFile(orgId:String,giverId:String,file:GiverFile):Result<String>
 suspend fun downloadStatement(statementId:String):Result<DocumentDownload>
 suspend fun retryStatement(statementId:String):Result<Unit>
 suspend fun requestStatement(orgId:String,giverId:String,year:Int):Result<String>
}
class SupabaseGiverExperienceRepository(private val client:GiverExperienceClient=GiverExperienceClient()):GiverExperienceRepository {
 override suspend fun stats(orgId:String,giverId:String)=runCatching {client.stats(orgId,giverId)}
 override suspend fun gifts(orgId:String,giverId:String)=runCatching {client.gifts(orgId,giverId)}
 override suspend fun statements(orgId:String,giverId:String)=runCatching {client.statements(orgId,giverId)}
 override suspend fun files(orgId:String,giverId:String)=runCatching {client.files(orgId,giverId)}
 override suspend fun upload(orgId:String,giverId:String,name:String,mime:String,bytes:ByteArray)=runCatching {client.upload(orgId,giverId,name,mime,bytes)}
 override suspend fun downloadFile(orgId:String,giverId:String,file:GiverFile)=runCatching {client.downloadFile(orgId,giverId,file)}
 override suspend fun downloadStatement(statementId:String)=runCatching {client.downloadStatement(statementId)}
 override suspend fun retryStatement(statementId:String)=runCatching {client.retryStatement(statementId)}
 override suspend fun requestStatement(orgId:String,giverId:String,year:Int)=runCatching {client.requestStatement(orgId,giverId,year)}
}
